import React, { useCallback } from "react";
import Button from "@material-ui/core/Button";
import clsx from "clsx";

import { IField } from "../../helpers";

import useStyles from "./styles";

interface IProps {
  field: IField;
  currentActiveId: string;
  onEntryButtonClick: (key: string, id: string) => void;
}

const EntryField = (props: IProps) => {
  const { field, currentActiveId, onEntryButtonClick } = props;

  const classes = useStyles();

  const handleEntryButtonClick = useCallback(
    (id: string) => () => {
      onEntryButtonClick(field.key, id);
    },
    [field]
  );

  return (
    <div>
      <div className={classes.entryHeader}>{field.label}</div>
      {field.entries.map(entry => {
        return (
          <Button
            key={entry.id}
            variant="outlined"
            className={clsx(classes.button, {
              [classes.buttonActive]: entry.id === currentActiveId
            })}
            onClick={handleEntryButtonClick(entry.id)}
          >
            {entry.description}
          </Button>
        );
      })}
    </div>
  );
};

export default React.memo(EntryField);
